import clsx from "clsx";
import type { ReactNode } from "react";
import styles from "./Stat.module.css";

export interface StatProps {
  label: ReactNode;
  /** A formatted value (use lib/format or <Quantity>/<Money>). */
  value: ReactNode;
  unit?: ReactNode;
  /** A change, already formatted with its sign ("+3", "−0.5 %"). */
  delta?: ReactNode;
  /** positive/negative are judged for the user, not by sign: fewer low-stock lots is positive. */
  deltaTone?: "positive" | "negative" | "neutral";
  /** Context under the value ("of 80 lots", "since last week"). */
  hint?: ReactNode;
  className?: string;
}

/** A key number with its label (dashboard tiles, page summaries). */
export function Stat({ label, value, unit, delta, deltaTone = "neutral", hint, className }: StatProps) {
  return (
    <div className={clsx(styles.stat, className)}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>
        <span>{value}</span>
        {unit ? <span className={styles.unit}>{unit}</span> : null}
        {delta ? (
          <span className={styles.delta} data-tone={deltaTone}>
            {delta}
          </span>
        ) : null}
      </dd>
      {hint ? <dd className={styles.hint}>{hint}</dd> : null}
    </div>
  );
}

/** Wrap Stats in a StatGroup: it renders the <dl> they belong to. */
export function StatGroup({ children, className }: { children: ReactNode; className?: string }) {
  return <dl className={clsx(styles.group, className)}>{children}</dl>;
}
